import { createSlice } from '@reduxjs/toolkit';

// Load settings from localStorage
const loadSettings = () => {
  try {
    const storedSettings = localStorage.getItem('appSettings');
    if (storedSettings) {
      return JSON.parse(storedSettings);
    }
  } catch (error) {
    console.error('Error loading app settings from localStorage:', error);
  }
  
  // Return default settings
  return {
    appTheme: 'teal',
    appDarkMode: false,
    appGradientEnabled: true,
    appHeaderFixed: true,
    appHeaderInverse: false,
    appSidebarFixed: true,
    appSidebarGrid: false,
  };
};

// Save settings to localStorage
const saveSettings = (settings) => {
  try {
    localStorage.setItem('appSettings', JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving app settings to localStorage:', error);
  }
};

const initialState = loadSettings();

const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    setAppTheme: (state, action) => {
      state.appTheme = action.payload;
      saveSettings(state);
    },
    setAppDarkMode: (state, action) => {
      state.appDarkMode = action.payload;
      saveSettings(state);
    },
    setAppGradientEnabled: (state, action) => {
      state.appGradientEnabled = action.payload;
      saveSettings(state);
    },
    setAppHeaderFixed: (state, action) => {
      state.appHeaderFixed = action.payload;
      saveSettings(state);
    },
    setAppHeaderInverse: (state, action) => {
      state.appHeaderInverse = action.payload;
      saveSettings(state);
    },
    setAppSidebarFixed: (state, action) => {
      state.appSidebarFixed = action.payload;
      saveSettings(state);
    },
    setAppSidebarGrid: (state, action) => {
      state.appSidebarGrid = action.payload;
      saveSettings(state);
    },
    resetAppSettings: (state) => {
      const defaultSettings = {
        appTheme: 'teal',
        appDarkMode: false,
        appGradientEnabled: true,
        appHeaderFixed: true,
        appHeaderInverse: false,
        appSidebarFixed: true,
        appSidebarGrid: false,
      };
      Object.assign(state, defaultSettings);
      saveSettings(state);
    },
  },
});

export const {
  setAppTheme,
  setAppDarkMode,
  setAppGradientEnabled,
  setAppHeaderFixed,
  setAppHeaderInverse,
  setAppSidebarFixed,
  setAppSidebarGrid,
  resetAppSettings,
} = appSettingsSlice.actions;

export default appSettingsSlice.reducer;

